import { useEffect, useState } from "react";
import { api } from "@/lib/api";

const RANGES = ["today", "week", "month", "all"];

function Row({ label, value, testId, tone }) {
  return (
    <div className="flex items-center justify-between border-b border-cream/10 py-2" data-testid={testId}>
      <p className="text-xs uppercase tracking-[0.2em] text-cream/60">{label}</p>
      <p className={`font-display text-lg ${tone === "gold" ? "text-gold" : tone === "green" ? "text-emerald-300" : "text-cream"}`}>{value}</p>
    </div>
  );
}

export default function HQFinance() {
  const [range, setRange] = useState("all");
  const [d, setD] = useState(null);

  useEffect(() => {
    api.get(`/hq/finance?range=${range}`).then((r) => setD(r.data));
  }, [range]);

  if (!d) return <div className="p-8 text-cream/50">Loading…</div>;

  return (
    <div className="p-6 max-w-4xl" data-testid="hq-finance">
      <p className="overline">Finance (demo)</p>
      <h1 className="font-display text-3xl tracking-tighter">Finance</h1>
      <p className="text-xs text-cream/60 mt-1 mb-6">{d.disclaimer}</p>
      <div className="flex gap-2 mb-6 flex-wrap">
        {RANGES.map((r) => (
          <button key={r} data-testid={`hq-finance-range-${r}`} onClick={() => setRange(r)}
                  className={`chip text-[10px] ${range === r ? "border-gold text-gold bg-gold/5" : ""}`}>{r}</button>
        ))}
      </div>

      <div className="grid md:grid-cols-2 gap-8">
        <div className="border border-emerald-400/30 p-5" data-testid="hq-finance-pro-block">
          <p className="overline text-emerald-300 mb-4">Money earned by Professionals</p>
          <p className="font-display text-4xl text-emerald-300">${d.professional_earnings}</p>
          <p className="text-[10px] uppercase tracking-[0.2em] text-cream/50 mt-1">Gross service value: ${d.gross_service_value}</p>
        </div>
        <div className="border border-gold/40 p-5" data-testid="hq-finance-kutz-block">
          <p className="overline text-gold mb-4">KUTZ revenue</p>
          <p className="font-display text-4xl text-gold">${d.kutz_platform_fees}</p>
          <p className="text-[10px] uppercase tracking-[0.2em] text-cream/50 mt-1">Fee waivers granted (repeat loyalty): {d.fee_waivers_count} · ${d.fee_waivers_value_demo}</p>
        </div>
      </div>

      <div className="mt-8 border border-cream/10 p-5">
        <p className="overline mb-3">Details</p>
        <Row testId="hq-fin-row-gross"   label="Gross service value"       value={`$${d.gross_service_value}`} />
        <Row testId="hq-fin-row-pro"     label="Professional earnings"      value={`$${d.professional_earnings}`} tone="green" />
        <Row testId="hq-fin-row-fees"    label="KUTZ platform fees"         value={`$${d.kutz_platform_fees}`} tone="gold" />
        <Row testId="hq-fin-row-waivers" label="Fee waivers (count / demo $)" value={`${d.fee_waivers_count} · $${d.fee_waivers_value_demo}`} />
        <Row testId="hq-fin-row-payout"  label="Outstanding payout placeholder" value={`$${d.outstanding_payout_placeholder}`} />
      </div>

      <div className="mt-6 border border-cream/10 p-5" data-testid="hq-fin-refunds">
        <p className="overline mb-3">Demo refund / credit adjustments</p>
        {(!d.demo_refund_adjustments || d.demo_refund_adjustments.length === 0) && <p className="text-[10px] text-cream/50">No demo adjustments recorded.</p>}
        {d.demo_refund_adjustments && d.demo_refund_adjustments.map((r, i) => (
          <div key={i} className="flex items-center justify-between border-b border-cream/10 py-2 text-xs">
            <span>{new Date(r.at).toLocaleString()} · {r.action}</span>
            <span className="text-cream/70">{r.amount_demo ? `$${r.amount_demo}` : "—"}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
